module.exports = __webpack_public_path__ + "img/right.389a659f.png";